import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "area_title" }
const _hoisted_3 = { class: "area_button" }
const _hoisted_4 = { class: "area_body" }
const _hoisted_5 = { class: "area_section" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "area_body" }
const _hoisted_8 = { class: "area_section" }
const _hoisted_9 = { class: "area_button area_button_top" }
const _hoisted_10 = { class: "flex ac" }
const _hoisted_11 = { class: "flex ac" }
const _hoisted_12 = { class: "select-wrap" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "area_section" }
const _hoisted_15 = { class: "area_table" }
const _hoisted_16 = { class: "area_table_head" }
const _hoisted_17 = { class: "select-wrap" }
const _hoisted_18 = { class: "total_length" }
const _hoisted_19 = { class: "area_table_body" }
const _hoisted_20 = { class: "area_section" }
const _hoisted_21 = { class: "area_button area_button_top" }
const _hoisted_22 = { class: "area_section" }
const _hoisted_23 = { class: "area_table" }
const _hoisted_24 = { class: "area_table_head" }
const _hoisted_25 = { class: "select-wrap" }
const _hoisted_26 = { class: "total_length" }
const _hoisted_27 = { class: "area_table_body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_ClientDetail = _resolveComponent("ClientDetail")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_HistoryDetail = _resolveComponent("HistoryDetail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _cache[11] || (_cache[11] = _createElementVNode("p", null, "상담 목록", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push({ name: 'clientDetail', params: { id: $setup.state.idx } })))
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("span", null, "기초 기록으로 연계", -1)
            ]))])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ClientDetail, {
              idx: $setup.state.idx
            }, null, 8, ["idx"])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push({ name: 'counselAdd', params: { id: $setup.state.idx } })))
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("span", null, "새 상담기록 작성", -1)
              ]))]),
              _createElementVNode("div", _hoisted_10, [
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  for: "moveNumber",
                  class: "area_label_tit"
                }, "이동연번", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "moveNumber",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.moveNumber) = $event)),
                  placeholder: "연번"
                }, null, 512), [
                  [_vModelText, $setup.state.moveNumber]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[16] || (_cache[16] = _createElementVNode("label", {
                  for: "moveNumber",
                  class: "area_label_tit"
                }, "이동부서", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.moveDept) = $event))
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("option", { value: "0" }, "선택해주세요.", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.deptListForMove, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.name
                      }, _toDisplayString(item.name), 9, _hoisted_13))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, $setup.state.moveDept]
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "active",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.move && $setup.move(...args)))
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("span", null, "이동", -1)
                ]))])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("select", {
                    name: "orderType",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.order) = $event)),
                    onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.fnGetList(1)))
                  }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("option", { value: "0" }, "최근순", -1),
                    _createElementVNode("option", { value: "1" }, "과거순", -1)
                  ]))], 544), [
                    [_vModelSelect, $setup.state.order]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("notice.total")) + " : " + _toDisplayString($setup.CommonUtils.numberFormat($setup.pageState.length)) + " " + _toDisplayString(_ctx.$t("notice.count")), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_DataGrid, {
                  list: $setup.pageState.list,
                  columns: $setup.pageState.fields,
                  totalLength: $setup.pageState.length,
                  perPage: $setup.pageState.perPage,
                  cntPage: $setup.pageState.cntPage,
                  "current-page": $setup.pageState.currentPage,
                  isLoading: $setup.pageState.isLoading,
                  onOnRowClick: $setup.fnRowClick,
                  onOnPaging: $setup.fnGetList,
                  onOnNextPage: $setup.fnGoPage,
                  onOnPrevPage: $setup.fnGoPage,
                  onOnFirstPage: $setup.fnGoPage,
                  onOnLastPage: $setup.fnGoPage
                }, null, 8, ["list", "columns", "totalLength", "perPage", "cntPage", "current-page", "isLoading", "onOnRowClick", "onOnPaging", "onOnNextPage", "onOnPrevPage", "onOnFirstPage", "onOnLastPage"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showHistoryModal()))
              }, [...(_cache[18] || (_cache[18] = [
                _createElementVNode("span", null, "새 이력 작성", -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("select", {
                    name: "orderType",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.orderForHistory) = $event)),
                    onChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.getHistoryList(1)))
                  }, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("option", { value: "0" }, "최근순", -1),
                    _createElementVNode("option", { value: "1" }, "과거순", -1)
                  ]))], 544), [
                    [_vModelSelect, $setup.state.orderForHistory]
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("notice.total")) + " : " + _toDisplayString($setup.CommonUtils.numberFormat($setup.pageStateForHistory.length)) + " " + _toDisplayString(_ctx.$t("notice.count")), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_DataGrid, {
                  list: $setup.pageStateForHistory.list,
                  columns: $setup.pageStateForHistory.fields,
                  totalLength: $setup.pageStateForHistory.length,
                  perPage: $setup.pageStateForHistory.perPage,
                  cntPage: $setup.pageStateForHistory.cntPage,
                  "current-page": $setup.pageStateForHistory.currentPage,
                  isLoading: $setup.pageStateForHistory.isLoading,
                  onOnRowClick: $setup.fnRowClickForHistory,
                  onOnPaging: $setup.getHistoryList,
                  onOnNextPage: $setup.fnGoPageForHistory,
                  onOnPrevPage: $setup.fnGoPageForHistory,
                  onOnFirstPage: $setup.fnGoPageForHistory,
                  onOnLastPage: $setup.fnGoPageForHistory
                }, null, 8, ["list", "columns", "totalLength", "perPage", "cntPage", "current-page", "isLoading", "onOnRowClick", "onOnPaging", "onOnNextPage", "onOnPrevPage", "onOnFirstPage", "onOnLastPage"])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowHistoryModal)
      ? (_openBlock(), _createBlock(_component_HistoryDetail, {
          key: 1,
          idx: $setup.state.historyIdx,
          clIdx: $setup.state.idx,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModalForHistory
        }, null, 8, ["idx", "clIdx", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}